import { Translation } from "../model/Language.js";
import { BaseElementOptions, BaseElement } from "./BaseElement.js";

export interface ToolbarOptions extends BaseElementOptions {
    // element?: HTMLDivElement;
    orientation?: "horizontal" | "vertical";
}

interface ToolbarItemGroup {
    key: string;
    element: HTMLDivElement;
}

export class Toolbar extends BaseElement {

    private _items: ToolbarItem[] = [];
    private _groups: ToolbarItemGroup[] = [];

    public create(options: ToolbarOptions): this {
        options = e5.object.merge({
            orientation: "vertical"
        } as ToolbarOptions, options);


        // this.create(options, options.element || this.createElement());

        // if (options.element) {
        //     options.element.querySelectorAll(".awi-toolbar__group").forEach((group) => {
        //         this._groups.push({
        //             element: group as any,
        //             key: group.getAttribute("data-group") || "default"
        //         })
        //     });
        // }

        super.create(options);

        this.setElement(this.createElement());

        this.element.classList.add("awi-toolbar--" + options.orientation);

        return this;
    }

    protected createElement(): HTMLDivElement {
        var e = document.createElement("div");
        e.className = "awi-toolbar";
        return e;
    }

    public add(options: ToolbarItemOptions): ToolbarItem {
        options = e5.object.merge({
            group: "default"
        } as ToolbarItemOptions, options);

        var group = this.getGroup(options.group);
        if (!group) {
            group = {
                element: document.createElement("div"),
                key: options.group
            };
            group.element.classList.add("awi-toolbar__group");
            group.element.setAttribute("data-group", group.key);
            this.element.appendChild(group.element);
            this._groups.push(group);
        }

        var item = new ToolbarItem(group, options);
        this._items.push(item);

        group.element.appendChild(item.element);

        return item;
    }

    private getGroup(key: string): ToolbarItemGroup {
        for (var group of this._groups) {
            if (group.key === key) {
                return group;
            }
        }
        return null;
    }
}

export interface ToolbarItemOptions {
    icon: string;
    group?: string;
    iconActive?: string;
    active?: boolean;
    cssClass?: string;
    label: Translation;
    labelActive?: Translation;
    type?: "button" | "pressed" | "expanded";
}

export class ToolbarItem {

    public readonly element: HTMLButtonElement;
    public readonly group: ToolbarItemGroup;

    private _iconElement: HTMLSpanElement;
    private _icon: string;
    private _iconActive: string;
    private _label: Translation;
    private _labelActive: Translation;
    private _type: "button" | "pressed" | "expanded";

    constructor(group: ToolbarItemGroup, options: ToolbarItemOptions) {

        options = e5.object.merge({
            active: false,
            type: "button",
            group: "default"
        } as ToolbarItemOptions, options);

        this._type = options.type;
        this.group = group;

        this._icon = options.icon;
        this._iconActive = options.iconActive || options.icon;

        this._label = lang.type("@title", options.label);

        if (options.labelActive) {
            this._labelActive = lang.type("@title", options.labelActive);
        }

        this.element = document.createElement("button");
        this.element.className = "awi-toolbar__item";
        this.element.setAttribute("role", "button");

        lang.set(this.element, this._label);

        this._iconElement = document.createElement("span");
        this._iconElement.className = "awi-toolbar__item-icon " + options.icon;
        this.element.appendChild(this._iconElement);


        if (this._type === "pressed") {
            this.element.setAttribute("aria-pressed", "false");
        }
        else if (this._type === "expanded") {
            this.element.setAttribute("aria-expanded", "false");
        }

        this.element.setAttribute("aria-disabled", this.disabled ? "true" : "false");

        this.active = options.active;

        if (options.cssClass) {
            this.element.classList.add(options.cssClass);
        }
    }

    public get active(): boolean {
        return this.element.classList.contains("awi-toolbar__item--active");
    }

    public set active(value: boolean) {
        if (value === this.active) {
            return;
        }
        this.element.classList.toggle("awi-toolbar__item--active", value);
        this.setIcon(value ? this._iconActive : this._icon);
        if (this._labelActive) {
            lang.set(this.element, value ? this._labelActive : this._label);
        }

        if (this._type === "pressed") {
            this.element.setAttribute("aria-pressed", value ? "true" : "false");
        }
        else if (this._type === "expanded") {
            this.element.setAttribute("aria-expanded", value ? "true" : "false");
        }
    }

    public get disabled(): boolean {
        return this.element.disabled;
    }

    public set disabled(value: boolean) {
        this.element.disabled = value;
        this.element.setAttribute("aria-disabled", value ? "true" : "false");
    }

    private setIcon(icon: string): void {
        this._iconElement.className = "awi-toolbar__item-icon " + icon;
    }
}